import { Color } from "three"
import { beachSand, deepSeaSand, sandDuneTop, underseaSand, wetSand } from "./colors"

// y is now in [-1, 1], where 0 is sea level
export default function getShoalSandColor2(y: number, outColor: Color): void {
  let colorA: Color, colorB: Color
  let t: number

  if (y >= 1) {
    outColor.copy(sandDuneTop)
    return
  } else if (y >= 0) {
    colorA = beachSand
    colorB = sandDuneTop
    t = y
  } else if (y >= -0.5) {
    colorA = wetSand
    colorB = beachSand
    t = (y + 0.5) / 0.5
  } else if (y >= -0.9) {
    colorA = underseaSand
    colorB = wetSand
    t = (y + 0.9) / 0.4
  } else if (y >= -1.0) {
    colorA = deepSeaSand
    colorB = underseaSand
    t = (y + 1.0) / 0.1
  } else {
    outColor.copy(deepSeaSand)
    return
  }

  outColor.lerpColors(colorA, colorB, t)
}
